// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1LInP","insightsList":"newBusinessInsightsMenu_insightsList__3pdXq","active":"newBusinessInsightsMenu_active__14Uio"};